import { useState } from 'react';
import dayjs from 'dayjs';
import { CalendarPopup } from 'components/Dashboard/Filters/ui/DateFilter';
import useTranscriptsSort from 'components/Dashboard/Transcripts/useTranscriptsSort';
import normalize from 'components/Dashboard/utilities/normalizeString';
import time from 'utils/time';

const EVENTS_CATEGORIES = ['All', 'Commons', 'Lords', 'Committees', 'Westminster Hall', 'Other'];
const SORT_OPTIONS = ['Status', 'Latest requested'];

const TranscriptsFilters = (props) => {
  const { section, createFiltersState } = props;
  const { activeSection, setActiveSection } = createFiltersState;
  const { sortOrder, setSortOrder } = useTranscriptsSort();

  return (
    <div className='outside-filters-around-container h-100'>
      <div className='outside-filters-box'>
        <div className='outside-filters-spacing-container'>
          {section === 'your-transcripts' && (
            <>
              <div className='popup-outside-filter-container'>
                <h3 className='title-h5-bold mb-3'>Sort by</h3>
                <RadioButtonOptions options={SORT_OPTIONS} selected={sortOrder} onSelect={setSortOrder} />
              </div>
              <div className='popup-outside-filter-container'>
                <h3 className='title-h5-bold mb-3'>Category</h3>
                <RadioButtonOptions options={EVENTS_CATEGORIES} selected={activeSection} onSelect={setActiveSection} />
              </div>
            </>
          )}
          {section === 'create' && <CreateTranscriptsFilters {...createFiltersState} />}
        </div>
      </div>
    </div>
  );
};

const RadioButtonOptions = (props) => {
  const { options, selected, onSelect } = props;
  return (
    <>
      {options.map((name) => (
        <div key={name} className='radio-button mb-2'>
          <input id={normalize(name)} type='radio' checked={selected === name} onChange={() => onSelect(name)} />
          <label htmlFor={normalize(name)}>{name}</label>
        </div>
      ))}
    </>
  );
};

const CreateTranscriptsFilters = (props) => {
  const { activeSection, setActiveSection, date, setDate } = props;
  const [calendarState, setCalendarState] = useState({
    active: false,
    filterProperty: '',
    selectedDay: dayjs().toDate(),
    name: '',
    range: { from: '', to: '' },
  });

  return (
    <>
      <div className='popup-outside-filter-container'>
        <h3 className='title-h5-bold mb-3'>Date</h3>
        <TranscriptionDatePicker
          dateState={{ date, setDate }}
          calendarState={calendarState}
          setCalendarState={setCalendarState}
        />
      </div>
      <div className='popup-outside-filter-container'>
        <h3 className='title-h5-bold mb-3'>Category</h3>
        <RadioButtonOptions options={EVENTS_CATEGORIES} selected={activeSection} onSelect={setActiveSection} />
      </div>
      <CalendarPopup
        showPopup={calendarState.active}
        calendarState={calendarState}
        setCalendarState={setCalendarState}
        ApplyCalendarFilters={() => setDate(dayjs(calendarState.selectedDay).format('YYYY-MM-DD'))}
        setShowPopup={(val) => setCalendarState({ ...calendarState, active: val })}
        noFutureDatesAllowed={true}
        selectedMonth={calendarState.selectedDay}
        handleMonthChange={() => {}}
      />
    </>
  );
};

const TranscriptionDatePicker = (props) => {
  const { dateState, calendarState, setCalendarState } = props;
  const { date, setDate } = dateState;

  const dateToShow = dayjs(date).format('YYYY-MM-DD');
  const currentDate = dayjs().format('YYYY-MM-DD');
  const showCloseButton = date && date !== currentDate;
  const sameYear = dayjs().isSame(dateToShow, 'year');
  const dateFormat = sameYear ? 'dddd, Do MMMM' : 'dddd, Do MMMM YYYY';

  return (
    <div
      className={`w-100 pointer section-filter-button position-relative d-inline-block general-button border rounded-pill border-grey bg-blue-hovered light-90-text ${showCloseButton ? 'pl-3' : 'px-3'} specific-y-padding-5 specific-right-padding-45 nowrap-item transition-default`}
      onClick={() => setCalendarState({ ...calendarState, active: !calendarState?.active })}
    >
      {time(dateToShow)?.format(dateFormat)}
      {showCloseButton && (
        <span
          className='bg-main-blue text-white position-absolute circle-button-26 top-4 right-5 d-flex align-items-center justify-content-center hover-opacity-85 transition-200 pointer'
          onClick={(e) => {
            e.stopPropagation();
            setDate(currentDate);
          }}
        >
          <span className='icon-close paragraph-p5' />
        </span>
      )}
    </div>
  );
};

export default TranscriptsFilters;
